// Contract-status pill vocabulary: the locked label for each managed-contract
// status and the palette its pill renders in.
//
// Its own leaf module so a read-only surface (the report summary's essentials
// card) can render the same pill as the interactive StatusPillButton without
// importing the button — and so a test that mocks the button component does
// not have to reproduce this map in its mock factory.

import type { ManagedContractStatus } from "../../types";

export const CONTRACT_STATUS_LABEL: Record<ManagedContractStatus, string> = {
  draft: "Draft",
  active: "Active",
  expired: "Expired",
  terminated: "Terminated",
  archived: "Archived",
};

export const CONTRACT_STATUS_PILL_CLASS: Record<ManagedContractStatus, string> =
  {
    draft: "bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300",
    active:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400",
    expired:
      "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-500",
    terminated:
      "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400",
    archived:
      "bg-slate-100 text-slate-400 dark:bg-slate-700/50 dark:text-slate-500",
  };
